module.exports = __webpack_public_path__ + "static/media/Yes.0068d12c.png";